import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomePageInitParamsResolver } from './containers/home-page/home-page-init-params.resolver';

@NgModule({
  imports: [RouterModule],
  providers: [HomePageInitParamsResolver],
})
export class HomePageModule {}
